<template>
  <div class="d-flex justify-content-end">
    <McTableFilter
      :hasResetFilters="false"
      :activeFilters="activeFilters"
      :parseFilterDataMappings="parseFilterDataMappings"
      @submit="handleInput"
    >
      <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
        <div class="mc-modal-content__filter-download-video-hoistory">
          <div class="mc-modal__filter-item">
            <FormulateInput
              v-model="formValues.vehicleId"
              type="value-help-v2"
              name="vehicleId"
              :label="$t('global.object.licensePlate')"
              trackBy="id"
              :placeholder="$t('global.form.select') + ' ' + $t('global.object.licensePlate')"
              :displayedBy="'licensePlate'"
              :fullObject="fullObjects['vehicleId']"
              :listGetter="resourcefulQuery.vehicle"
              :multiple="true"
              :tableFields="vehicleField"
              :modalTitle="$t('global.form.select') + ' ' + $t('global.object.licensePlate')"
              :canSelectAll="true"
              @update:formValues="updateFormValues({ key: 'vehicleId', value: $event })"
              @update:fullObject="updateFullObjects({ key: 'vehicleId', value: $event })"
            />
          </div>
          <div class="mc-modal__filter-item">
            <div class="formulate-input">
              <label class="formulate-input-label">{{ $t('trackVideo.camera') }}</label>
              <Multiselect
                v-model="formValues['channel']"
                :class="`formulate-input-element input-md mc-video-history__download-filter-channel`"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :searchable="false"
                :options="channelOptions"
                label="label"
                track-by="value"
                :placeholder="$t('global.form.select') + ' ' + $t('trackVideo.camera')"
              />
            </div>
          </div>

          <div class="mc-modal__filter-item">
            <FormulateInput
              name="periode"
              isShow="true"
              :label="$t('videoHistory.modalFilter.periode')"
              :placeholder="$t('videoHistory.modalFilter.periode')"
              type="date-picker"
              datepickerType="date"
              valueType="YYYY-MM-DD"
              format="DD MMM YYYY"
              titleFormat="DD MMM YYYY"
              rangeSeparator=" - "
              :range="true"
              :draft="true"
              :confirm="true"
              :confirm-text="$t('global.action.apply')"
              :shortcuts="makeShortcuts"
              :lang="datePickerLang"
              :value="formValues.periode"
            />
          </div>
        </div>
      </template>
    </McTableFilter>

    <div class="ms-2">
      <McButton
        v-if="isSelected"
        :variant="'secondary-red'"
        :text="$t('global.delete')"
        icon="icon-outline_trash"
        @click="showDeleteModal"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import McTableFilter from '@/components/McTableFilter'
import McButton from '@/components/McButton'
import datePickerLang from '@/helpers/date-picker-lang'
import moment from 'moment'
import { GET_VEHICLE_VIDEO_FILTER } from '@/services/api/trackvideo/video.js'
import Multiselect from 'vue-multiselect'
moment.locale('id')

export default {
  components: {
    McTableFilter,
    McButton,
    Multiselect,
  },

  props: {
    activeFilters: {
      required: true,
    },
    handleChangeActiveFilters: {
      type: Function,
    },
    isSelected: {},
    showDeleteModal: {},
  },

  data() {
    return {
      periode: [],
      vehicleList: [],
      serviceLocation: {
        internal: false,
        eksternal: false,
      },
      serviceLocType: [],
      pastDate: moment().subtract(1, 'years'),
      futureEnd: moment().add(1, 'years'),
      channelOptions: [],
      channelValue: null,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    vehicleField() {
      return [
        {
          label: this.$t('report.fields.licensePlate'),
          key: 'licensePlate',
          isSortable: false,
        },
        {
          label: this.$t('report.fields.vehicleType'),
          key: 'vehicleType',
          isSortable: false,
        },
        {
          label: 'Status',
          key: 'status',
          isSortable: false,
        },
      ]
    },
    shortcutsToday() {
      const dateStart = new Date()
      dateStart.setHours(0, 0, 0, 0)
      return [dateStart, new Date()]
    },

    shortcutsYesterday() {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24)
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24)
      dateStart.setHours(0, 0, 0, 0)
      dateEnd.setHours(23, 59, 59, 999)
      return [dateStart, dateEnd]
    },

    shortcuts7DaysLeft() {
      const dateStart = new Date()
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * 6)
      dateStart.setHours(0, 0, 0, 0)
      return [dateStart, new Date()]
    },

    shortcuts30DaysLeft() {
      const date = new Date()
      date.setHours(0, 0, 0, 0)
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 29)
      return [date, new Date()]
    },

    shortcutThisMonth() {
      const date = new Date()
      date.setHours(0, 0, 0, 0)
      date.setTime(date.getTime() - 3600 * 1000 * 24 * (date.getDate() - 1))
      return [date, new Date()]
    },

    shortcutsLastMonth() {
      const awal = new Date()
      awal.setTime(awal.getTime() - 3600 * 1000 * 24 * awal.getDate())
      awal.setTime(awal.getTime() - 3600 * 1000 * 24 * (awal.getDate() - 1))

      const akhir = new Date()
      akhir.setTime(akhir.getTime() - 3600 * 1000 * 24 * akhir.getDate())

      return [awal, akhir]
    },

    makeShortcuts() {
      return [
        { text: this.$t('global.time.today'), onClick: () => this.shortcutsToday },
        { text: this.$t('global.time.yesterday'), onClick: () => this.shortcutsYesterday },
        { text: this.$t('global.time.last7Days'), onClick: () => this.shortcuts7DaysLeft },
        { text: this.$t('global.time.last30Days'), onClick: () => this.shortcuts30DaysLeft },
        { text: this.$t('global.time.thisMonth'), onClick: () => this.shortcutThisMonth },
        { text: this.$t('global.time.lastMonth'), onClick: () => this.shortcutsLastMonth },
      ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
    },

    datePickerLang() {
      return datePickerLang()
    },

    resourcefulQuery() {
      const self = this
      return {
        vehicle: async (opts) => {
          const filter = {
            orderBy: JSON.stringify({ licensePlate: 'asc' }),
            motionStatus: this.hasAccess(['assisted_motion_status:read'])
              ? ['assisted', 'idle', 'moving', 'offline', 'parking', 'unknown']
              : undefined,
          }
          if (opts.search) {
            filter['search'] = opts.search
          }

          const response = await this.$apollo.query({
            query: GET_VEHICLE_VIDEO_FILTER,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })
          const vehicles = response.data.vehicleVideoTrackers.vehicleVideoTrackers.map(
            (vehicle) => {
              let status
              if (vehicle.vehicle.status === 'I') {
                status = self.$t('master.status.aktif')
              } else if (vehicle.vehicle.status === 'R') {
                status = self.$t('master.status.perbaikan')
              } else {
                status = self.$t('master.status.arsip')
              }
              return {
                ...vehicle.vehicle,
                licensePlate: vehicle?.parent
                  ? vehicle?.parent?.vehicle?.licensePlate
                  : vehicle.vehicle.licensePlate,
                vehicleType: vehicle.vehicle.vehicleType
                  ? `${vehicle.vehicle.vehicleType.manufacturer ?? '-'} / ${
                      vehicle.vehicle.vehicleType.model ?? '-'
                    } / ${vehicle.vehicle.vehicleType.type ?? '-'} `
                  : '-',
                status,
              }
            }
          )
          return {
            metadata: {
              total_count: vehicles.length,
              page: 1,
            },
            data: {
              paginated_result: vehicles,
              ids: vehicles.map((vehicle) => vehicle.id),
            },
            isPagination: false,
          }
        },
      }
    },
    parseFilterDataMappings() {
      return {
        vehicleId: 'vehicleId',
        channel: 'channel',
        periode: 'periode',
      }
    },
  },

  mounted() {
    const totalCamera = 16
    for (let i = 1; i <= totalCamera; i++) {
      this.channelOptions.push({
        label: this.$t('trackVideo.camera') + ' ' + i,
        value: i,
      })
    }
  },

  methods: {
    onSearchVehicle(vehicles, search) {
      search = search.toLowerCase()

      return vehicles.filter(
        (vehicle) =>
          vehicle.licensePlate.toLowerCase().includes(search) ||
          vehicle.vehicleType.toLowerCase().includes(search)
      )
    },

    handleSelectChannel(channel) {
      if (channel === 'all') {
        this.channel = {
          all: true,
          CH01: false,
          CH02: false,
          CH03: false,
          CH04: false,
        }
      } else {
        this.channel.all = false
        this.channel[channel] = !this.channel[channel]
        let obj = { ...this.channel }
        let objArr = []
        Object.keys(obj).forEach(function (key) {
          if (obj[key]) {
            objArr.push(true)
          }
        })

        if (objArr.length === 4 || objArr.length === 0) {
          this.channel = {
            all: true,
            CH01: false,
            CH02: false,
            CH03: false,
            CH04: false,
          }
          return
        }
      }
    },

    handleInput(value) {
      this.$emit('handleChangeActiveFilters', value)
    },

    filterOrderStatus(key) {
      if (key == 'all') {
        this.filterStatus = {
          all: true,
          draft: false,
          confirmation: false,
          inProgress: false,
          validation: false,
          done: false,
          cancel: false,
        }
      } else {
        this.filterStatus.all = false
        this.filterStatus[key] = !this.filterStatus[key]

        let obj = { ...this.filterStatus }
        let objArr = []
        Object.keys(obj).forEach(function (key) {
          if (obj[key]) {
            objArr.push(true)
          }
        })

        if (objArr.length === 6 || objArr.length === 0) {
          this.filterStatus = {
            all: true,
            draft: false,
            confirmation: false,
            inProgress: false,
            validation: false,
            done: false,
            cancel: false,
          }
          return
        }
      }
    },

    filterServiceLocation(key) {
      this.serviceLocation[key] = !this.serviceLocation[key]

      let obj = { ...this.serviceLocation }

      let objArr = []
      Object.keys(obj).forEach(function (key) {
        const capitalKey = key.charAt(0).toUpperCase() + key.slice(1)

        if (obj[key] === true) {
          objArr.push(capitalKey)
        }
      })

      this.serviceLocType = objArr
    },
  },
}
</script>
